import React from 'react'
import AppNavigator from './appNavigator'
import { connect } from 'react-redux'
import { configureAuth } from '../../helpers/authHelpers'
import { BrowserRouter } from 'react-router-dom'

class NavigatorWrapper extends React.Component {
    constructor(props) {
        super(props)
        configureAuth()
    }

    render() {
        return (
            <BrowserRouter basename={process.env.PUBLIC_URL}>
                <AppNavigator />
            </BrowserRouter>
        )
    }
}

const mapStateToProps = (store) => ({ appStore: store.app })
export default connect(mapStateToProps)(NavigatorWrapper)
